/* Quick-add: own AJAX path + toast notification.
 *
 * v2 change: does NOT auto-open the cart drawer anymore. Auto-open broke
 * multi-item shopping (drawer covered the page after every add). Instead:
 *   - On success: bump .cart-count badges + replace cart-drawer markup
 *     silently (so when the customer eventually taps the cart icon, the
 *     drawer is fresh) + show a small bottom toast for ~2s.
 *   - The merchant can still tap the cart icon any time to review.
 *
 * Flow:
 *   1. Event delegation on document — catches dynamically-rendered buttons.
 *   2. Read data-variant-id + data-product-title from the button.
 *   3. POST /cart/add.js with id + quantity + sections=cart-drawer.
 *   4. Parse response.sections['cart-drawer'], swap .cart-drawer-inner silently.
 *   5. Bump .cart-count badges by 1.
 *   6. Flash button green with "✓ Ajouté".
 *   7. Show toast at bottom-center with "✓ {product_title} ajouté".
 *   8. Dispatch theme:cart:updated for refund-ack / other listeners.
 */
(function () {
  'use strict';

  var BUTTON_SELECTOR = '.quick-add-btn--add';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function setLoading(btn, on) {
    if (on) btn.classList.add('is-loading');
    else btn.classList.remove('is-loading');
  }
  function flash(btn, cls, ms) {
    btn.classList.add(cls);
    setTimeout(function () { btn.classList.remove(cls); }, ms || 1500);
  }

  function bumpCartCount(by) {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      var cur = parseInt(el.textContent, 10);
      if (isNaN(cur)) cur = 0;
      el.textContent = (cur + by).toString();
    });
  }

  function replaceCartDrawerInner(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var freshInner = doc.querySelector('.cart-drawer-inner');
    var liveInner = document.querySelector('cart-drawer .cart-drawer-inner') || document.querySelector('.cart-drawer-inner');
    if (freshInner && liveInner) {
      liveInner.replaceWith(freshInner);
      // Re-run lazy-load on the freshly-injected drawer (Refine helper).
      if (typeof window.lazyloading === 'function') {
        freshInner.querySelectorAll('.lazy-loading-image').forEach(function (el) {
          try { window.lazyloading(el); } catch (e) {}
        });
      }
    }
  }

  function showToast(productTitle, isError) {
    var el = document.getElementById('quick-add-toast');
    if (!el) return;
    var template = (window.__quickAddI18n && window.__quickAddI18n.toast_added) || '✓ {name} ajouté';
    var msg = isError
      ? ((window.__quickAddI18n && window.__quickAddI18n.toast_error) || 'Erreur lors de l’ajout')
      : template.replace('{name}', productTitle || '');
    el.textContent = msg;
    el.hidden = false;
    if (isError) el.classList.add('is-error'); else el.classList.remove('is-error');
    // Force a reflow before adding is-visible so the transition runs.
    void el.offsetWidth;
    el.classList.add('is-visible');
    clearTimeout(el.__hideTimer);
    el.__hideTimer = setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () {
        if (!el.classList.contains('is-visible')) el.hidden = true;
      }, 300);
    }, 2000);
  }

  function addToCart(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    var productTitle = btn.getAttribute('data-product-title') || '';
    if (!variantId) {
      console.warn('[quick-add] button has no data-variant-id', btn);
      flash(btn, 'is-error', 2000);
      showToast(productTitle, true);
      return;
    }
    setLoading(btn, true);

    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', '1');
    body.append('sections', 'cart-drawer');
    body.append('sections_url', window.location.pathname);

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
      body: body
    })
      .then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, status: res.status, data: data }; });
      })
      .then(function (result) {
        setLoading(btn, false);
        if (!result.ok || result.status >= 400) {
          console.warn('[quick-add] /cart/add returned', result.status, result.data);
          flash(btn, 'is-error', 2000);
          showToast(productTitle, true);
          return;
        }
        // Silently refresh the cart drawer so it's ready when the customer opens it.
        if (result.data && result.data.sections && result.data.sections['cart-drawer']) {
          replaceCartDrawerInner(result.data.sections['cart-drawer']);
        }
        bumpCartCount(1);
        flash(btn, 'is-added', 1300);
        showToast(productTitle, false);
        // Two events fire so listeners can pick the granularity they want:
        //   cart:item-added → for any code that wants to react to ONE item being added
        //   theme:cart:updated → broader "cart changed" signal (refund-ack, etc.)
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { variantId: variantId, productTitle: productTitle, item: result.data } }));
        document.dispatchEvent(new CustomEvent('theme:cart:updated'));
        // NOTE: deliberately NOT opening the cart drawer. Auto-open broke multi-item shopping.
      })
      .catch(function (err) {
        setLoading(btn, false);
        console.error('[quick-add] network error', err);
        flash(btn, 'is-error', 2000);
        showToast(productTitle, true);
      });
  }

  // Event delegation on document — handles dynamically-added buttons too.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest(BUTTON_SELECTOR);
    if (!btn) return;
    if (btn.hasAttribute('disabled') || btn.classList.contains('is-loading')) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    // Stop the click from bubbling to the wrapping product-card <a> (which would navigate to the PDP).
    e.preventDefault();
    e.stopPropagation();
    addToCart(btn);
  });
})();
